// extracted by mini-css-extract-plugin
export default {"wrapper":"N2-z","message":"O2-z","image":"P2-z"};